import { Component } from '@angular/core';
import { RosterContainerComponent } from './Roster/roster-container.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RosterContainerComponent]
})
export class AppComponent {
  title = 'MeetingRoster';
}
